import React, { useState } from "react";

interface Column {
  key: string;
  label: string;
  render?: (value: any, row: any) => React.ReactNode;
}

interface AdminTableProps {
  columns: Column[];
  data: any[];
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
}

const PAGE_SIZE = 10;

export default function AdminTable({ columns, data, onEdit, onDelete }: AdminTableProps) {
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(data.length / PAGE_SIZE);
  const pageData = data.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              {columns.map((col) => (
                <th key={col.key} className="text-left text-xs uppercase tracking-wider text-gray-500 px-4 py-3">{col.label}</th>
              ))}
              {(onEdit || onDelete) && <th className="text-left text-xs uppercase tracking-wider text-gray-500 px-4 py-3">Actions</th>}
            </tr>
          </thead>
          <tbody className="divide-y">
            {pageData.map((row, idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                {columns.map((col) => (
                  <td key={col.key} className="px-4 py-3 text-sm">
                    {col.render ? col.render(row[col.key], row) : String(row[col.key] ?? "")}</td>
                ))}
                {(onEdit || onDelete) && (
                  <td className="px-4 py-3 text-sm space-x-2">
                    {onEdit && <button onClick={() => onEdit(row)} className="text-indigo-600 hover:text-indigo-800">Edit</button>}
                    {onDelete && <button onClick={() => onDelete(row)} className="text-red-600 hover:text-red-800">Delete</button>}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="flex justify-between items-center mt-4">
          <button onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0} className="px-3 py-1 border rounded text-sm disabled:opacity-50">Prev</button>
          <span className="text-sm text-gray-600">Page {page + 1} of {totalPages}</span>
          <button onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))} disabled={page >= totalPages - 1} className="px-3 py-1 border rounded text-sm disabled:opacity-50">Next</button>
        </div>
      )}
    </div>
  );
}